// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"203cb4f7","196":"20ce03eb","207":"817d8ee4","227":"c2650afe"}[chunkId] + ".chunk.css";
};